import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KnowledgeBaseService, KBArticle } from '../../services/knowledge-base.service';

@Component({
  selector: 'app-kb-article-edit',
  templateUrl: './kb-article-edit.component.html',
  styleUrls: ['./kb-article-edit.component.css']
})
export class KbArticleEditComponent implements OnInit {
  article: KBArticle = null;
  changeNote = '';
  loading = true;
  saving = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private kb: KnowledgeBaseService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = true;
      this.kb.getArticleBySlug(params['articleSlug']).subscribe(article => {
        this.article = article;
        this.loading = false;
      });
    });
  }

  save() {
    this.error = '';
    if (!this.changeNote.trim()) {
      this.error = 'A change note is required describing what you changed.';
      return;
    }
    this.saving = true;
    this.kb.saveArticle(this.article, this.changeNote).subscribe({
      next: (saved) => {
        this.saving = false;
        this.router.navigate(['/knowledge-base', saved.categorySlug, saved.slug]);
      },
      error: () => {
        this.saving = false;
        this.error = 'Failed to save. Please try again.';
      }
    });
  }

  cancel() {
    this.router.navigate(['/knowledge-base', this.article.categorySlug, this.article.slug]);
  }
}
